// extracted by mini-css-extract-plugin
export default {"photo":"FeedPhotosItem_photo__9kdQ6","visualizacao":"FeedPhotosItem_visualizacao__nkCCV"};